// HKDSE 2025 Paper 1 Knowledge Graph Samples - Combined
// Merged from all part files

import { hkdse2025Samples_complete } from './hkdse2025Samples_complete.js';
import { hkdse2025Samples_part2 } from './hkdse2025Samples_part2.js';
import { hkdse2025Samples_part3 } from './hkdse2025Samples_part3.js';
import { hkdse2025Samples_part4 } from './hkdse2025Samples_part4.js';

export const hkdse2025Samples_combined = {
  ...hkdse2025Samples_complete,
  ...hkdse2025Samples_part2,
  ...hkdse2025Samples_part3,
  ...hkdse2025Samples_part4
};

// Export individual parts for backward compatibility
export { hkdse2025Samples_complete, hkdse2025Samples_part2, hkdse2025Samples_part3, hkdse2025Samples_part4 }; 